import clamp from './clamp.js'

function create ({$nav, $navIcons}) {
  // Ensures colours don't change in dark mode
  if ($nav.hasClass('dark-mode')) {
    return {
      update: () => {},
      remove: () => {},
    };
  } else {
    // Height at which to start changing the color as a multiple of the nav height
    const colorChangeMultiplier = 2.3;

    // Duration to fade the text to black in ms
    const textFadeDuration = 400;

    const height = $nav.height();
    let mode = 'light';
    let reset = false;
    let color = $nav.parent().css('background-color');

    // Removes color applied by color change
    function remove() {
      $nav
        .css({
          'background-color': '',
          'color': '',
          'transition-duration': '0s',
        });
      $navIcons
        .css({
          'background-color': '',
          'transition-duration': '0s',
        });
      reset = true;
    }

    function update({offset, mobileMenuIsOpen, isSticky, scrollPosition, isHidden, topOffset}) {
      if (isHidden || mobileMenuIsOpen) {
        return;
      }
      const prevOffset = offset;
      offset = (isSticky ? scrollPosition : topOffset) - offset.parent;
      if (!reset && prevOffset === offset) {
        return;
      }
      const scrollTopRatio = offset / (height * colorChangeMultiplier);
      if (scrollTopRatio < 1) {
        const scrollTopPercent = clamp({value: scrollTopRatio, min:0, max: 1}) * 100;
        const bgColor = `color-mix(in srgb, ${color}, var(--black) ${scrollTopPercent}%)`;
        if (mode === 'dark' || reset) {
          mode = 'light';
          reset = false;
          const color = 'var(--black)';
          $nav
            .addClass('light-mode')
            .removeClass('dark-mode')
            .css({
              'transition': `color ${textFadeDuration}ms`,
              'background-color': bgColor,
              color
            });
          $navIcons
            .css({
              'transition': `background-color ${textFadeDuration}ms`,
              'background-color': color,
            });
          // Removes the text fade css property when it is finished
          setTimeout(function(){
            $nav.css('transition-duration', '0s');
            $navIcons.css('transition-duration', '0s');
          }, textFadeDuration);
        } else {
          $nav.css('background-color', bgColor);
        }
      } else if (mode === 'light' || reset) {
        mode = 'dark';
        reset = false;
        const color = 'var(--white)';
        const bgColor = 'var(--black)';
        $nav
          .addClass('dark-mode')
          .removeClass('light-mode')
          .css({
            'background-color': bgColor,
            color
          })
        $navIcons
          .css('background-color', color);
      }
    }
    return {update, remove};
  }
}
export {create};